import { createApiClient } from "./createApiClient";
import {
  BASE_URL,
  EPICENTER_BASE_URL,
  STUDENT_PORTAL_BASE_URL,
  CY_SSO_BASE_URL,
} from "./constants";

const API = new createApiClient(BASE_URL);
const API_CUSTOMERDEMO = new createApiClient(
  process.env.REACT_APP_CUSTOMERDEMO_HTTP_BASE_URL
);
const API_EPICENTER = new createApiClient(EPICENTER_BASE_URL);
const API_STUDENT_PORTAL = new createApiClient(STUDENT_PORTAL_BASE_URL);
const API_CY_SSO = new createApiClient(CY_SSO_BASE_URL);

export { API, API_CUSTOMERDEMO, API_EPICENTER, API_STUDENT_PORTAL, API_CY_SSO };
